"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseString = exports.parseFile = exports.parseStream = exports.parse = exports.ParserOptions = exports.CsvParserStream = void 0;
const fs = __importStar(require("fs"));
const stream_1 = require("stream");
const ParserOptions_1 = require("./ParserOptions");
const CsvParserStream_1 = require("./CsvParserStream");
__exportStar(require("./types"), exports);
var CsvParserStream_2 = require("./CsvParserStream");
Object.defineProperty(exports, "CsvParserStream", {
  enumerable: true,
  get: function () {
    return CsvParserStream_2.CsvParserStream;
  }
});
var ParserOptions_2 = require("./ParserOptions");
Object.defineProperty(exports, "ParserOptions", {
  enumerable: true,
  get: function () {
    return ParserOptions_2.ParserOptions;
  }
});
const parse = args => {
  return new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(args));
};
exports.parse = parse;
const parseStream = (stream, options) => {
  return stream.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseStream = parseStream;
const parseFile = function (location) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fs.createReadStream(location).pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseFile = parseFile;
const parseString = (string, options) => {
  const rs = new stream_1.Readable();
  rs.push(string);
  rs.push(null);
  return rs.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseString = parseString;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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